<template>
  <div>
    <div id="instructions">
      <h1>I need a new pet</h1>
      <div v-if="state == states.WAITING_FOR_OFFLINE">
        I need your help but let's keep this private, please turn off your
        internet to continue
      </div>
      <div v-else>
        <!-- <div v-if="state == states.WAITING_FOR_INPUT"> -->
        but I don't know which animal to get? Dog? Too poopy. Cat? Too picky.
        <h2>Which unusual animal should I choose?</h2>
        <!-- </div>
        <div v-if="state == states.WAITING_FOR_RANDOM_DESTRUCTION">
          <h1>Thanks</h1>
          Now to narrow it down, let's destroy some of these cards at random!
          <button v-on:click="destroyrandom()">DESTROY</button>
        </div>
        <div
          v-if="
            state == states.WAITING_FOR_DESTRUCTION ||
            state == states.IN_DESTRUCTION
          "
        >
          <h1>Thanks</h1>
          Now to narrow it down, YOU should destroy cards until there's one
          left.
        </div> -->
      </div>
    </div>
    <div class="container" v-if="state != states.WAITING_FOR_OFFLINE">
      <form @submit.prevent="progressState()" id="billets">
        <transition name="fade">
          <input
            name="billet"
            v-model="msg[0]"
            v-if="!deleted[0]"
            v-on:blur="progressState()"
            v-on:focus="cardfocus(0)"
            :readonly="!canedit"
          />
        </transition>
        <!-- <transition name="fade">
          <input
            name="billet"
            v-model="msg[1]"
            v-if="!deleted[1]"
            v-on:blur="progressState()"
            v-on:focus="cardfocus(1)"
            :readonly="!canedit"
          />
        </transition>
        <transition name="fade">
          <input
            name="billet"
            v-model="msg[2]"
            v-if="!deleted[2]"
            v-on:blur="progressState()"
            v-on:focus="cardfocus(2)"
            :readonly="!canedit"
          />
        </transition>
        <transition name="fade">
          <input
            name="billet"
            v-model="msg[3]"
            v-if="!deleted[3]"
            v-on:blur="progressState()"
            v-on:focus="cardfocus(3)"
            :readonly="!canedit"
          />
        </transition>
        <transition name="fade">
          <input
            name="billet"
            v-model="msg[4]"
            v-if="!deleted[4]"
            v-on:blur="progressState()"
            v-on:focus="cardfocus(4)"
            :readonly="!canedit"
          />
        </transition>
        <transition name="fade">
          <input
            name="billet"
            v-model="msg[5]"
            v-if="!deleted[5]"
            v-on:blur="progressState()"
            v-on:focus="cardfocus(5)"
            :readonly="!canedit"
          />
        </transition> -->
      </form>
      <button v-on:click="progressState()">done</button>
    </div>
    <div v-if="state == states.ALL_BAD_INPUT">
      <h1>Curious</h1>
      None of those look like animals to me. Can you try some alternatives?
    </div>
    <div v-if="state == states.DESTROYED">
      Now call me, but don't ruin the surprise!
      {{
        optionResults[0].number[0] +
        " (" +
        optionResults[0].number.slice(1, 4) +
        ") " +
        optionResults[0].number.slice(4, 7) +
        "-" +
        optionResults[0].number.slice(7, 11)
      }}
    </div>
  </div>
</template>
<script>
import {} from "../main";
import animals from "../animal";

export default {
  name: "Demo",
  components: {
    // Parallax
    // VideoBg
  },
  mounted: function () {
    // this.msg.push(Object.keys(animals)[0]);
    window.addEventListener("online", this.progressState);
    window.addEventListener("offline", this.progressState);
    this.progressState();
  },
  data() {
    return {
      msg: [],
      deleted: [false, false, false, false, false, false],
      optionResults: [],
      state: "waiting_for_offline",
      canedit: true,
      states: {
        WAITING_FOR_OFFLINE: "waiting_for_offline",
        WAITING_FOR_INPUT: "waiting_for_input",
        ALL_BAD_INPUT: "all_bad_input",
        WAITING_FOR_RANDOM_DESTRUCTION: "waiting_for_random_destruction",
        WAITING_FOR_DESTRUCTION: "waiting_for_destruction",
        IN_DESTRUCTION: "in_destruction",
        DESTROYED: "destroyed",
      },
    };
  },
  methods: {
    destroyrandom: function () {},
    cardfocus: function (i) {
      // eslint-disable-next-line
      console.log("focused");
      if (this.state == this.states.WAITING_FOR_DESTRUCTION) {
        // eslint-disable-next-line
        console.log("deleted");
        this.$set(this.deleted, i, true);
      }
      this.progressState();
    },
    progressState: function () {
      this.state = this.getState();
      if (
        this.state == this.states.WAITING_FOR_INPUT ||
        this.state == this.states.ALL_BAD_INPUT
      ) {
        this.canedit = true;
      } else {
        this.canedit = false;
      }
    },
    getState: function () {
      if (navigator.onLine) {
        // eslint-disable-next-line
        console.log("offline ");
        return this.states.WAITING_FOR_OFFLINE;
      }
      if (this.msg.length < 1) return this.states.WAITING_FOR_INPUT;
      this.msg.forEach((input) => {
        if (input.length < 1) {
          return this.states.WAITING_FOR_INPUT;
        }
      });
      return this.sanitize();
    },
    sanitize: function () {
      var options = [];
      var animalHits = 0;
      this.optionResults = [];
      this.msg.forEach((input) => {
        input = input.toLowerCase();
        var words = input.split(" ");
        var lastword = words[words.length - 1];
        var result = { input: input };
        if (animals[input]) {
          result["number"] = animals[input];
          animalHits++;
        } else if (animals[lastword]) {
          result["number"] = animals[lastword];
          animalHits++;
        } else {
          // eslint-disable-next-line
          console.log("failed " + input);
        }
        this.optionResults.push(result);
        // eslint-disable-next-line
        console.log(input);
        options.push({ input });
      });
      if (animalHits == 1) {
        return this.states.DESTROYED;
      } else if (animalHits == 0) {
        return this.states.ALL_BAD_INPUT;
      } else {
        return this.states.WAITING_FOR_RANDOM_DESTRUCTION;
      }
    },
  },
};
</script>
<style>
input {
  font-size: 1em;
  width: 30%;
  min-width: 200px;
}
.container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-evenly;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>